import { useQuery } from "@tanstack/react-query";
import { capitalize } from "lodash";
import PropTypes from "prop-types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ThreeDots } from "react-loader-spinner";
import ClassificationIcon from "../../../../../components/ClassificationIcon";
import { remapedUiClassificationLabel } from "../../../../../utils";
import networkApi from "../../../../network/api";

const SampleReportGridClassification = ({ url }) => {
  const { data, isPending: isLoading } = useQuery({
    queryKey: ["reportGridUrlReport", url],
    queryFn: () =>
      networkApi.urlReport({ url }).then(resp => resp.data.classification)
  });

  const classificationLabel = data ? capitalize(data) : "Not found";

  if (isLoading) {
    return <ThreeDots color="#000" height={5} width={75} />;
  }

  return (
    <div className={`sample-report-grid__item`}>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-sample-report-grid-classification`}>
            {remapedUiClassificationLabel(classificationLabel)}
          </Tooltip>
        }
      >
        <span>
          <ClassificationIcon
            classification={classificationLabel}
            showTooltip={false}
            className="me-5"
          />
          <span className={"vertical-align-middle"}>
            {remapedUiClassificationLabel(classificationLabel)}
          </span>
        </span>
      </OverlayTrigger>
    </div>
  );
};

SampleReportGridClassification.propTypes = {
  url: PropTypes.string
};
export default SampleReportGridClassification;
